// extracted by extract-css-chunks-webpack-plugin
module.exports = {"event_date":"EventDate__event_date--20Nj_"};